export default __webpack_public_path__ + "static/media/tocaya.c7e43126.png";